package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Colour

class Moon(sun: Sun) : Planet(sun) {
    private val DEF_MOON_COLOR = SP_Colour(240, 240, 240,255)
    override fun addPerturbations() {
        super.addPerturbations()
        val Ms: Double = mSun.mOEs.get(M)
        val Mm = mOEs[M]
        val Nm = mOEs[N]
        val ws: Double = mSun.mOEs.get(w)
        val wm = mOEs[w]
        val Ls = Ms + ws
        val Lm = Mm + wm + Nm
        val D = Lm - Ls
        val F = Lm - Nm
        addPerturbationsForMoonsLongitude(F, D, Mm, Ms)
        addPerturbationsForMoonsLatitude(F, D, Mm)
    }

    protected fun addPerturbationsForMoonsLongitude(
        F: Double,
        D: Double,
        Mm: Double,
        Ms: Double
    ) {
        mlonEcl = mlonEcl + -1.274 * MathD.sinD(Mm - 2 * D) //  (the Evection)
        mlonEcl = mlonEcl + +0.658 * MathD.sinD(2 * D) // (the Variation)
        mlonEcl = mlonEcl + -0.186 * MathD.sinD(Ms) // (the Yearly Equation)
        mlonEcl = mlonEcl + -0.059 * MathD.sinD(2 * Mm - 2 * D)
        mlonEcl = mlonEcl + -0.057 * MathD.sinD(Mm - 2 * D + Ms)
        mlonEcl = mlonEcl + +0.053 * MathD.sinD(Mm + 2 * D)
        mlonEcl = mlonEcl + +0.046 * MathD.sinD(2 * D - Ms)
        mlonEcl = mlonEcl + +0.041 * MathD.sinD(Mm - Ms)
        mlonEcl = mlonEcl + -0.035 * MathD.sinD(D) // (the Parallactic Equation)
        mlonEcl = mlonEcl + -0.031 * MathD.sinD(Mm + Ms)
        mlonEcl = mlonEcl + -0.015 * MathD.sinD(2 * F - 2 * D)
        mlonEcl = mlonEcl + +0.011 * MathD.sinD(Mm - 4 * D)
    }

    protected fun addPerturbationsForMoonsLatitude(
        F: Double,
        D: Double,
        Mm: Double
    ) {
        mlatEcl = mlatEcl + -0.173 * MathD.sinD(F - 2 * D)
        mlatEcl = mlatEcl + -0.055 * MathD.sinD(Mm - F - 2 * D)
        mlatEcl = mlatEcl + -0.046 * MathD.sinD(Mm + F - 2 * D)
        mlatEcl = mlatEcl + +0.033 * MathD.sinD(F + 2 * D)
        mlatEcl = mlatEcl + +0.017 * MathD.sinD(2 * Mm + F)
    }

    protected fun addPerturbationsForMoonsDistance(
        Mm: Double,
        D: Double
    ) {
        m_r = m_r + -0.58 * MathD.sinD(Mm - 2 * D)
        m_r = m_r + -0.46 * MathD.sinD(2 * D)
    }

    init {
        rgbColour = DEF_MOON_COLOR
        name = "Moon"
        abbrevName = "\u263D"
        setOrbitalElementsData(OE_MOON)
    }
}